// Backoffice auth flow helpers (localStorage, claimFlow stash/redeem pattern):
//  • stash/redeem the admin's intended /admin/* path across the login roundtrip — hitting the
//    panel logged-out sends you to /login and, after auth, straight back into the panel
//    (redeemed in OnboardingRouter for admins only, before any tenant gates);
//  • remember the last-used console so /admin opens where the operator left off.
// Values are constrained to '/admin' paths — a tampered stash can't redirect elsewhere.

const RETURN_KEY = 'flathero.admin.return';
const LAST_KEY = 'flathero.admin.last';

function isAdminPath(p: string | null): p is string {
  return !!p && p.startsWith('/admin');
}

export function stashAdminReturn(path: string): void {
  if (isAdminPath(path)) localStorage.setItem(RETURN_KEY, path);
}

/** Get-and-clear: the stash survives exactly one login roundtrip. */
export function redeemAdminReturn(): string | null {
  const v = localStorage.getItem(RETURN_KEY);
  localStorage.removeItem(RETURN_KEY);
  return isAdminPath(v) ? v : null;
}

export function rememberAdminPath(path: string): void {
  if (isAdminPath(path) && path !== '/admin') localStorage.setItem(LAST_KEY, path);
}

/** Where /admin should land: the last-used console, else null (caller falls back to inbox). */
export function lastAdminPath(): string | null {
  const v = localStorage.getItem(LAST_KEY);
  return isAdminPath(v) ? v : null;
}
